export default __webpack_public_path__ + "static/media/CGU.5e38b5eb.pdf";